/** Operator-facing labels — supplier goods receipt / inventory receipt only; no AP or payment wording. */

export const SUPPLIER_GOODS_RECEIPT_FLOW_OPERATOR_LABELS = {
  actionStart: '입고 확인',
  actionStartEn: 'Supplier goods receipt',
  flowLabel: '공급업체 입고 확인',
  stageLabel: '공급업체 입고',
  taskLabel: '입고 증빙 확인',
  evidenceSlotLabel: '구매입고 증빙',
  draftTypeLabel: '구매입고 전표',
  openSuccess: '입고 확인 Flow를 시작했습니다.',
  openFailed: '입고 확인 Flow를 시작하지 못했습니다.',
  unwiredHandler: '입고 확인 실행 경로가 연결되지 않았습니다.',
} as const;
